import { useTranslation } from "react-i18next";

const marathiDigits = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

const useFormattedNumbers = (numbersArray) => {
  const { i18n } = useTranslation();

  const formattedNumbers = numbersArray.map((number) => {
    if (i18n.language === "mr") {
      return number
        .toString()
        .split("")
        .map((digit) => marathiDigits[digit] || digit)
        .join("");
    }
    return number;
  });

  return formattedNumbers;
};

export default useFormattedNumbers;
